module.exports = __webpack_public_path__ + "static/media/close-up-flower-cake.44d97cff.jpg";